import {type RouteRecordRaw} from 'vue-router';
import councilservice from './councilservice';
import meetingservice from './meetingservice';

export default ([] as RouteRecordRaw[]).concat(meetingservice, councilservice);